import React from 'react';
import { Box, Typography } from '@mui/material';
import EmailAutocompleteTextField from '../../EmailAutocompleteTextField';

const EmailQuestion = ({ 
  question, 
  value = '', 
  onChange, 
  interpolateText, 
  answers, 
  error 
}) => {
  const handleChange = (newValue) => {
    onChange(newValue);
  };

  return (
    <Box>
      <Typography variant="h5" gutterBottom sx={{ mb: 3, fontWeight: 600, whiteSpace: 'pre-line' }}>
        {interpolateText(question.text, answers)}
      </Typography>
      
      <EmailAutocompleteTextField
        fullWidth
        value={value}
        onChange={handleChange}
        placeholder={question.placeholder || 'Enter your email address...'}
        error={!!error}
        helperText={error}
        size="medium"
        autoFocus
        sx={{
          '& .MuiOutlinedInput-root': {
            fontSize: '1.1rem'
          }
        }}
      />
    </Box>
  );
};

export default EmailQuestion;